(() => {
  const OVERVIEW_SELECTOR = '[data-ts-collection-overview-root]';
  const PRICE_SELECTOR = '[data-ts-collection-price-summary]';

  const formatJPY = (value) =>
    new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      maximumFractionDigits: 0,
    }).format(value);

  const normalizeText = (value) => (value || '').toString().replace(/\s+/g, ' ').trim();

  const getMedian = (numbers) => {
    if (!numbers.length) return null;

    const sorted = [...numbers].sort((left, right) => left - right);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      return Math.round((sorted[middle - 1] + sorted[middle]) / 2);
    }

    return sorted[middle];
  };

  const refreshOverview = (root) => {
    if (!root) return;

    const content = root.querySelector('[data-ts-collection-overview-content]');
    const toggle = root.querySelector('[data-ts-collection-overview-toggle]');
    if (!content || !toggle) return;

    const expanded = root.dataset.expanded === 'true';
    content.classList.toggle('is-collapsed', !expanded);

    const overflow = content.scrollHeight > content.clientHeight + 2;
    toggle.classList.toggle('is-hidden', !overflow);
    toggle.disabled = !overflow;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? '閉じる' : 'もっと見る';

    if (!overflow) {
      root.dataset.expanded = 'true';
      content.classList.remove('is-collapsed');
      toggle.setAttribute('aria-expanded', 'true');
    }
  };

  const initOverview = (root) => {
    if (!root || root.dataset.tsCollectionOverviewReady === 'true') return;

    const toggle = root.querySelector('[data-ts-collection-overview-toggle]');
    if (!toggle) return;

    root.dataset.expanded = 'false';
    toggle.addEventListener('click', () => {
      const nextExpanded = root.dataset.expanded !== 'true';
      root.dataset.expanded = nextExpanded ? 'true' : 'false';
      refreshOverview(root);
    });

    window.addEventListener('resize', () => refreshOverview(root));
    root.dataset.tsCollectionOverviewReady = 'true';
    requestAnimationFrame(() => refreshOverview(root));
    window.setTimeout(() => refreshOverview(root), 180);
  };

  const initPriceSummary = (root) => {
    if (!root || root.dataset.tsCollectionPriceReady === 'true') return;

    const medianTarget = root.querySelector('[data-ts-collection-median]');
    if (!medianTarget) return;

    const existingText = normalizeText(medianTarget.textContent);
    if (existingText && existingText !== '集計中') {
      root.dataset.tsCollectionPriceReady = 'true';
      return;
    }

    let prices = [];
    try {
      const parsed = JSON.parse(root.dataset.tsCollectionPrices || '[]');
      if (Array.isArray(parsed)) {
        prices = parsed.map((value) => Number(value)).filter((value) => Number.isFinite(value) && value > 0);
      }
    } catch (error) {
      prices = [];
    }

    const median = getMedian(prices);
    medianTarget.textContent = median ? formatJPY(median / 100) : 'データ確認中';
    root.dataset.tsCollectionPriceReady = 'true';
  };

  const boot = () => {
    document.querySelectorAll(OVERVIEW_SELECTOR).forEach((root) => initOverview(root));
    document.querySelectorAll(PRICE_SELECTOR).forEach((root) => initPriceSummary(root));
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:section:select', boot);
})();
